import $ from 'jquery';
import polyfills from './modules/polyfills';
import navigation from './modules/navigation';
import cart from './modules/cart';
import ticketSelector from './modules/ticket-selector';
import order from './modules/order';
import branchBar from './modules/branch-bar';
import analytics from './modules/analytics';

// Bootstrap (v3) doesn't have proper module support, so we need to make jQuery global and `require` bootstrap
global.$ = global.jQuery = $;
import 'bootstrap/js/dist/dropdown';

// Initialize everything on document ready
$(() => {
  polyfills.init();
  navigation.init();
  cart.init();
  ticketSelector.init();
  order.init();
  branchBar.init();
  analytics.init();
});
